module.exports = __webpack_public_path__ + "img/open-close_12month01.db055cb8.png";